import { SystemStyleObject } from '@chakra-ui/react';

const NumberInputTheme = {
  baseStyle: {
    field: <SystemStyleObject>{
      _focusVisible: {
        boxShadow: 'outline',
        outline: 'none',
      },
      borderColor: 'neutral.90',
      borderRadius: '4',
      borderStyle: 'solid',
      borderWidth: '1px',
      height: '42',
      paddingLeft: '12',
    },
  },
  sizes: {
    medium: {
      field: {
        boxShadow: 'inner',
        fontSize: '3',
        height: '48',
      },
    },
    small: {
      field: {
        boxShadow: 'innerSmall',
        fontSize: '2',
        height: '32',
      },
    },
  },
};

export default NumberInputTheme;
